import { cssVar } from './variables.js';
import { css } from 'styled-components';

const backgrounds = {
  primary: cssVar["color-bg-primary"],
  secondary: cssVar["color-bg-secondary"],
  tertiary: cssVar["color-bg-tertiary"],
  contrast: cssVar["color-bg-contrast"],
  ["contrast-reverse"]: cssVar["color-bg-contrast-reverse"],
  transparent: "transparent"
};
const getCssBackground = (defaultBackground) => css([
  ``,
  ``
], (p) => {
  const bgKey = p.background ?? defaultBackground;
  if (bgKey) {
    return css([
      `background:`,
      `;`
    ], backgrounds[bgKey]);
  }
  return ``;
});

export { getCssBackground };
//# sourceMappingURL=cssBackground.js.map
